import React from "react";

import { Controller, useFormContext } from "react-hook-form";

import { AgentNodeForm } from "src/agentNode/types";
import { Card } from "src/base-components/Card";
import { AutocompleteCodeInput } from "src/base-components/CodeInput/EditorCodeInput";
import { useIsFieldHighlighted } from "src/flowGraph/canvasSearch/CanvasSearchHighlightContext";

type Props = {
  immutable: boolean;
};

export const AgentResponseMapping: React.FC<Props> = ({ immutable }) => {
  const { control, getValues } = useFormContext<AgentNodeForm>();
  const responseId = getValues("response.default.id");
  const isSearchHighlighted = useIsFieldHighlighted(responseId);

  return (
    <div className="flex flex-col gap-y-2">
      <span className="font-inter-semibold-13px text-gray-800">Output</span>
      <Card variant="default">
        <Card.Content>
          <div className="flex flex-col gap-y-2">
            <p className="font-inter-normal-12px text-gray-500">
              Agent response will be saved to:
            </p>
            <Controller
              control={control}
              name="response.default.mapped_to"
              render={({ field }) => (
                <AutocompleteCodeInput
                  dataLoc="agent-response-mapping"
                  disabled={immutable}
                  isSearchHighlighted={isSearchHighlighted}
                  placeholder="agent_response"
                  prefix="data."
                  value={field.value}
                  onChange={field.onChange}
                />
              )}
            />
          </div>
        </Card.Content>
      </Card>
    </div>
  );
};
